var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4636_1744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10C16.25 10.705 16.1325 11.3837 15.9175 12.0163L14.9 10.9987C14.9666 10.67 15.0001 10.3354 15 10V8.75C15 8.58424 15.0658 8.42527 15.1831 8.30806C15.3003 8.19085 15.4592 8.125 15.625 8.125C15.7908 8.125 15.9497 8.19085 16.0669 8.30806C16.1842 8.42527 16.25 8.58424 16.25 8.75V10ZM10 15C11.0225 15 11.9725 14.6938 12.765 14.1663L13.6625 15.065C12.7702 15.7121 11.7219 16.1103 10.625 16.2188V18.75H14.375C14.5408 18.75 14.6997 18.8158 14.8169 18.9331C14.9342 19.0503 15 19.2092 15 19.375C15 19.5408 14.9342 19.6997 14.8169 19.8169C14.6997 19.9342 14.5408 20 14.375 20H5.625C5.45924 20 5.30027 19.9342 5.18306 19.8169C5.06585 19.6997 5 19.5408 5 19.375C5 19.2092 5.06585 19.0503 5.18306 18.9331C5.30027 18.8158 5.45924 18.75 5.625 18.75H9.375V16.2188C7.83336 16.0638 6.40422 15.3418 5.36485 14.1927C4.32548 13.0436 3.74998 11.5494 3.75 10V8.75C3.75 8.58424 3.81585 8.42527 3.93306 8.30806C4.05027 8.19085 4.20924 8.125 4.375 8.125C4.54076 8.125 4.69973 8.19085 4.81694 8.30806C4.93415 8.42527 5 8.58424 5 8.75V10C5 11.3261 5.52678 12.5979 6.46447 13.5355C7.40215 14.4732 8.67392 15 10 15ZM13.75 3.75V9.84875L6.4475 2.54625C6.73368 1.7053 7.309 0.993196 8.07104 0.536708C8.83309 0.0802199 9.7324 -0.0910276 10.6089 0.0534521C11.4854 0.197932 12.2821 0.648762 12.8573 1.32568C13.4325 2.00261 13.7489 2.86169 13.75 3.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8576 13.2588L6.25012 7.65V10C6.24992 10.6566 6.42215 11.3018 6.74959 11.871C7.07702 12.4402 7.54817 12.9134 8.11591 13.2434C8.68364 13.5733 9.32807 13.7484 9.98471 13.7511C10.6413 13.7538 11.2872 13.584 11.8576 13.2588ZM2.05762 1.6925L17.0576 16.6925L17.9426 15.8075L2.94262 0.807503L2.05762 1.6925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4636_1744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneMuted);
export default __webpack_public_path__ + "static/media/microphoneMuted.8febb88ccc6877f649c49a7b3d454a80.svg";
export { ForwardRef as ReactComponent };